import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card } from '@totalsoft/rocket-ui';
import { Toc as TocIcon } from '@mui/icons-material';
import InsuranceConventionRisksContainer from './risks/InsuranceConventionRisksContainer';
import InsuranceConventionCommissionContainer from './commissions/InsuranceConventionCommissionContainer';
import InsuranceConventionInsurerContainer from '../details/insurers/InsuranceConventionInsurerContainer';
import InsuranceConventionConditionsContainer from './conditions/InsuranceConventionConditionsContainer';
import InsuranceConventionUsageTableContainer from './usageTable/InsuranceConventionUsageTableContainer';
import InsuranceConventionItemTypesContainer from './itemTypes/InsuranceConventionItemTypesContainer';
import InsuranceConventionPercentCalculationContainer from './percentCalculation/InsuranceConventionPercentCalculationContainer';
import InsuranceConventionDeductibleCostsContainer from './deductibleCosts/InsuranceConventionDeductibleCostsContainer';
import InsuranceConventionCoefficientsContainer from './coefficients/InsuranceConventionCoefficientsContianer';
import { NavPillsCardContainer } from 'components/common/Styles';
import NavPillsWithPrompt from 'features/common/dirtyInfo/components/NavPillsWithPrompt';

const InsuranceConventionDetailsComponent = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Card icon={TocIcon} iconColor='primary' title={t('InsuranceConventions.Details.Title')}>
      <NavPillsCardContainer disablePadding>
        <NavPillsWithPrompt
          fullWidth
          tabs={[
            {
              label: t('InsuranceConventions.Details.Conditions.Label'),
              content: <InsuranceConventionConditionsContainer productId={data?.productId} templateId={data?.genericFilterTemplateId} />
            },
            {
              label: t('InsuranceConventions.Details.Insurers.Title'),
              content: <InsuranceConventionInsurerContainer productId={data?.productId} />
            },
            {
              label: t('InsuranceConventions.Details.ItemTypes'),
              content: <InsuranceConventionItemTypesContainer productId={data?.productId} />
            },
            {
              label: t('InsuranceConventions.Details.Risks.Label'),
              content: <InsuranceConventionRisksContainer productId={data?.productId} />
            },
            {
              label: t('InsuranceConventions.Details.AgentFees'),
              content: <InsuranceConventionCommissionContainer productId={data?.productId} />
            },
            {
              label: t('InsuranceConventions.Details.PercentCalculation.Title'),
              content: <InsuranceConventionPercentCalculationContainer insuranceConventionData={data} />
            },
            {
              label: t('InsuranceConventions.Details.DeductibleExpenses'),
              content: <InsuranceConventionDeductibleCostsContainer productId={data?.productId} />
            },
            {
              label: t('InsuranceConventions.Details.Coeficients'),
              content: <InsuranceConventionCoefficientsContainer productId={data?.productId} />
            },
            {
              label: t('InsuranceConventions.Details.UsageTable.Label'),
              content: <InsuranceConventionUsageTableContainer productId={data?.productId} />
            }
          ]}
        />
      </NavPillsCardContainer>
    </Card>
  );
};

InsuranceConventionDetailsComponent.propTypes = {
  data: PropTypes.object
};

export default InsuranceConventionDetailsComponent;
